
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ammo",
      function () {
        return require("private-next-pages/ammo/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ammo"])
      });
    }
  